module.exports = __webpack_public_path__ + "assets/img/report_banner.785e933e.jpg";